module.exports = __webpack_public_path__ + "static/media/contacto.9f2d86d5.jpg";